<dialog-draggable-header>
   <span *ngIf="isRequestor; else addUserTitle">
      {{requestType === 'grant' ? 'Grant' : 'Deny'}} Access <br />
   </span>
   <ng-template #addUserTitle>
      Add User
   </ng-template>
</dialog-draggable-header>

<div *ngIf="isRequestor" class="name p-1 my-2">{{selectedRequestor.firstName}} {{selectedRequestor.lastName}}</div>

<gm-loading-spinner *ngIf="loading"></gm-loading-spinner>

<mat-dialog-content>
   <div class="deny-wrapper">
      <form *ngIf="requestType !== 'deny'; else denyAccess" class="flex-dialog-container" [formGroup]="addUserForm">
         <mat-form-field *ngIf="!isRequestor">
            <mat-label for="gmin">GMIN (9-digit number)</mat-label>
            <input #gminInput id="gmin" type="text" minLength="9" maxlength="9" matInput formControlName="gmin"
               autocomplete="off" placeholder="Search for user..." />
            <mat-spinner class="spinner" *ngIf="searchingUser" [diameter]="20">
            </mat-spinner>
         </mat-form-field>
         <ng-container *ngIf="!isRequestor">
            <div *ngIf="foundUser; else noUserFound">
               <p>Name: {{foundUser.firstName}} {{foundUser.lastName}}</p>
               <p>Email: {{foundUser.email}}</p>
            </div>
            <ng-template #noUserFound>
               <p>No user found.</p>
            </ng-template>
         </ng-container>
         <mat-error *ngIf="this.addUserForm.hasError('securityLevelConstSource') && !loading">
            All Super Users, Program MSEs, Regional MSEs, and EGMs must have access to ALL SOURCES.
         </mat-error>
         <mat-form-field>
            <mat-label for="roles">Security Level</mat-label>
            <mat-select id="roles" formControlName="userRoleId">
               <mat-option *ngFor="let userRole of roles" [value]="userRole.id">
                  {{userRole.userRole}}
               </mat-option>
            </mat-select>
         </mat-form-field>
         <mat-form-field>
            <mat-label for="sources">Design Source</mat-label>
            <mat-select id="sources" formControlName="userSourceId">
               <mat-option>Clear</mat-option>
               <mat-option *ngFor="let dSource of designSources" [value]="dSource.id">
                  {{dSource.sourceName}}
               </mat-option>
            </mat-select>
         </mat-form-field>
         <mat-form-field>
            <mat-label for="sources">Const Source</mat-label>
            <mat-select id="sources" formControlName="restrictedToId">
               <mat-option *ngFor="let source of constSources" [value]="source.id">
                  {{source.sourceName}}
               </mat-option>
            </mat-select>
         </mat-form-field>
         <mat-checkbox formControlName="active" color="primary">Active?</mat-checkbox>
      </form>
      <ng-template #denyAccess>
         <mat-form-field appearance="fill" class="container">
            <mat-label for="denyReason">Reason</mat-label>
            <textarea id="denyReason" matInput [(ngModel)]="denyReason" minlength="1" maxlength="128"
               required></textarea>
         </mat-form-field>
      </ng-template>
   </div>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">

   <button color="primary" [disabled]="!validFoundUser || loading || !this.addUserForm.valid"
      *ngIf="!isRequestor; else notRequestor" mat-raised-button (click)="onAddUserClick()"
      (keypress.enter)="onAddUserClick()">Add User</button>
   <ng-template #notRequestor>
      <button mat-raised-button color="primary" *ngIf="requestType === 'grant'; else denyBtn"
         (click)="onGrantUserClick()" (keypress.enter)="onGrantUserClick()"
         [disabled]="loading || !this.addUserForm.valid">Grant</button>
      <ng-template #denyBtn>
         <button mat-raised-button color="warn" (click)="onDenyUserClick()" (keypress.enter)="onDenyUserClick()"
            [disabled]="loading">Deny</button>
      </ng-template>
   </ng-template>
   <button mat-raised-button mat-dialog-close [disabled]="loading">Cancel</button>

</mat-dialog-actions>